module.exports = __webpack_public_path__ + "img/calendar.f7c490eb.svg";